import React from 'react'

const Footer = () => {
    return (
        <footer id="footer" class="footer py-60">
        <h1>Computer WORLD</h1>
        <p>&copy 2022 - Computer WORLD.
            All rights reserved.</p>
        <div class="social-icons">
            <i class="fab fa-facebook-f"></i>
            <i class="fab fa-twitter"></i>
            <i class="fab fa-google"></i>
            <i class="fab fa-youtube"></i>
            <i class="fab fa-github"></i>
        </div>
    </footer>
    )
}

export default Footer
